import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";
import { makeStyles } from "@material-ui/core/styles";
import Successpop from "./Successpop";

const useStyles = makeStyles((theme) => ({
  Deleteicon: {
    color: "grey",
    "&:hover, &.Mui-focusVisible": { color: "#FF0027" },
  },
  rootBlock: {
    width: "21rem",
    height: "16rem",
  },

  topScrollPaper: {
    margin: "35px",
    alignItems: "flex-start",
  },
  topPaperScrollBody: {
    verticalAlign: "top",
  },
  deletePopupNobutton: {
    width: "8rem",
    marginLeft: "5px",
    height: "1.75rem",
    backgroundColor: "#EEEEEE",
    borderRadius: "3px",
    opacity: 1,
    color:"#1f1f1f"
  },
  warningButton: {
    paddingTop: "20px !important",
    // color: "var(--unnamed-color-1f1f1f) !important",
    font: "normal normal bold 16px/22px Open Sans !important",
    color: "#1F1F1F !important",
    opacity: 1,
  },
}));

export default function ResponsiveDialog(props) {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  // const theme = useTheme();
  // const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <DeleteSweepIcon
        className={classes.Deleteicon}
        onClick={handleClickOpen}
      />

      <Dialog
        // fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        classes={{
          scrollPaper: classes.topScrollPaper,
          paperScrollBody: classes.topPaperScrollBody,
        }}
      >
        <div className={classes.rootBlock}>
          <DialogTitle id="responsive-dialog-title" align="center">
            <div className={classes.warningButton}>{"Warning!"}</div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText align="center">
              <img align="center" src="/images/warningicon.svg" />
            </DialogContentText>
          </DialogContent>
          <DialogContent>
            <DialogContentText>
              <p className="delete-report-popup">
                {" "}
                Are you sure to delete this entry?{" "}
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
          <Successpop onClick={handleClose} id = {props.row._id} getblockUsers={props.getblockUsers} handleClose={handleClose}/>

            <Button
              onClick={handleClose}
              // className="bg-eee"
              className={classes.deletePopupNobutton}
              autoFocus
            >
              No
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
}